import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomService } from '@nano/common/dom';
import { FileTypes } from '@nano/common/file';
import { ApiEndpoints, ApiService } from '@nano/core/api';
import { PaymentType } from '@nano/payment';
import { IbanAccount } from './account';
import { Observable } from 'rxjs';

export interface IncomingSwiftPaymentInstructionsRequest {
  paymentSystem: PaymentType.SWIFT;
  currencyCode: string;
  debtorCountryCode: string;
  debtorBankCountryCode: string;
  accountNumber: string;
}

export interface IncomingSwiftPaymentInstructionsResponse {
  beneficiary?: string;
  beneficiaryAddress?: string;
  iban?: string | null;
  accountNumber?: string | null;
  sortCode?: string | null;
  beneficiaryBank?: string;
  beneficiaryBankAddress?: string;
  swiftOrBic?: string;
  correspondentBankName?: string | null;
  correspondentBankSwiftCode?: string | null;
  correspondentBankAddress?: string | null;
  reference?: string;
  prohibitedIndustryList?: string[] | null;
}

@Injectable({ providedIn: 'root' })
export class AccountInformationService {
  constructor(
    private apiService: ApiService,
    private domService: DomService
  ) {}

  download(account: IbanAccount, language: string, filename: string): void {
    this.apiService.getBlob(ApiEndpoints.accountInformation(account.iban, language), FileTypes.pdf.mediaType).subscribe((data) => {
      const link = this.domService.createFileDownloadLink(data, filename);
      link.click();
    });
  }

  getSwiftIncomingPaymentInstructions(request: IncomingSwiftPaymentInstructionsRequest): Observable<IncomingSwiftPaymentInstructionsResponse> {
    const params = new HttpParams()
      .set('paymentSystem', request.paymentSystem)
      .set('currencyCode', request.currencyCode)
      .set('debtorCountryCode', request.debtorCountryCode)
      .set('debtorBankCountryCode', request.debtorBankCountryCode)
      .set('accountNumber', request.accountNumber);

    return this.apiService.get<IncomingSwiftPaymentInstructionsResponse>(ApiEndpoints.incomingPaymentInstructions(), params);
  }
}
